import { Flex } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useHistoryContent } from "@/entities/subscription-block/model/hooks";
import { AppButton, AppLoader } from "@/shared/Components";
import { HistoryItem } from "../history-item";

type Props = {
  onClose: () => void;
};

export const HistoryContent = ({ onClose }: Props) => {
  const { t } = useTranslation();
  const { data, isLoading } = useHistoryContent();

  if (isLoading) {
    return <AppLoader />;
  }

  return (
    <Flex vertical gap={32}>
      {data
        ? [...data]
            .sort((a, b) => dayjs(b.activeStartDate).diff(dayjs(a.activeStartDate)))
            .map((subscription) => (
              <HistoryItem key={subscription.tariffInstanceId} subscription={subscription} />
            ))
        : null}
      <AppButton type="primary" onClick={onClose} style={{ alignSelf: "center" }}>
        {t("common.close")}
      </AppButton>
    </Flex>
  );
};
